/* PRECISION CARRY ENGRAVING — generated order proof + readable placement metadata. */
(() => {
  const boot = () => {
    const form = document.querySelector("[data-pc-config-form]");
    if (!form) return;
    const lids = {
        slim: {
          black: "lid_true_black.png",
          red: "lid_true_red.png",
          blue: "lid_true_blue.png",
          gold: "lid_true_gold.png",
          green: "lid_true_green.png",
          gunmetal: "lid_true_grey.png",
        },
        thick: {
          black: "lid_true_black.png",
          red: "lid_true_red.png",
          blue: "lid_true_blue.png",
          gold: "lid_true_gold.png",
          green: "lid_true_green.png",
          gunmetal: "lid_true_grey.png",
        },
        rect: {
          black: "lid_rect_true_black.png",
          red: "lid_rect_true_red.png",
          blue: "lid_rect_true_blue.png",
          gold: "lid_rect_true_gold.png",
          green: "lid_rect_true_green.png",
          gunmetal: "lid_rect_true_grey.png",
        },
      },
      guides = {
        slim: { x: 56.8, y: 54.8, w: 57.7, h: 57.7 },
        thick: { x: 56.8, y: 54.8, w: 57.7, h: 57.7 },
        rect: { x: 50, y: 50, w: 76, h: 76 },
      },
      finishNames = {
        black: "Matte Black",
        red: "Red",
        blue: "Deep Blue",
        gold: "Gold",
        green: "forrest Green",
        gunmetal: "Dark Grey",
      },
      finishVariantNames = {
        black: ["Matte Black"],
        red: ["Red", "Anodized Red", "Ruby Red"],
        blue: ["Deep Blue"],
        gold: ["Gold"],
        green: ["forrest Green", "Forrest Green"],
        gunmetal: ["Dark Grey", "Gunmetal Grey"],
      },
      roundFrame = { cropLeft: 13.6, cropTop: 7.44, visible: 86.4 },
      stockVerticalAdjustment = {
        default: 1,
        "Buzztin Logo": 6,
        "American Flag": 2,
        "Dad Fuel": 0,
        "Dad Fuel II": 0,
        "Earned Not Given": 2,
        "Live Free": 3,
        "Wolf Head": 2,
      },
      stockSizeAdjustment = {
        "Buzztin Logo": 1.1,
        "American Flag": 1.23585,
        "Bald Eagle": 1.16699,
        "Compass Rose": 1.16699,
        "Deer Skull": 1.133,
        "Good Vibes Only": 0.90307,
        Skull: 0.857375,
        "Crossed Arrows": 0.98,
        "Eagle & Flag": 0.931,
        "Made in USA": 0.95,
      },
      model = form.querySelector("[data-pc-model]"),
      lid = document.querySelector("[data-pc-lid]"),
      stage = document.querySelector("[data-pc-stage]"),
      guide = document.querySelector("[data-pc-guide]"),
      art = document.querySelector("[data-pc-art]"),
      artImg = document.querySelector("[data-pc-art-image]"),
      artText = stage.querySelector("[data-pc-art-text]"),
      upload = form.querySelector("[data-pc-art-upload]"),
      text = form.querySelector("[data-pc-art-text]"),
      scale = form.querySelector("[data-pc-art-scale]"),
      feedback = form.querySelector("[data-pc-config-feedback]"),
      submitButton = form.querySelector('button[type="submit"]');
    let color = "black",
      design = "Buzztin Logo",
      uploadedPreview = null,
      drag = null,
      submitting = !1,
      uploadToken = 0,
      uploadBusy = !1,
      uploadReady = !1,
      uploadError = "",
      previewFile = null,
      stockArtworkSource = artImg.src,
      submissionUnconfirmed = !1,
      point = { x: 56.8, y: 44.7 };
    const requestedParams = new URLSearchParams(window.location.search),
      requestedModel = requestedParams.get("model"),
      requestedFinish = requestedParams.get("finish");
    (["slim", "thick", "rect"].includes(requestedModel) &&
      (model.value = requestedModel),
      requestedFinish &&
        Object.hasOwn(lids.slim, requestedFinish) &&
        (color = requestedFinish),
      form
        .querySelectorAll("[data-pc-color]")
        .forEach(button =>
          button.setAttribute(
            "aria-pressed",
            button.dataset.pcColor === color ? "true" : "false"
          )
        ));
    const isPdfFile = file => !!file && (
        String(file.type || "").split(";")[0].trim().toLowerCase() === "application/pdf" ||
        /\.pdf$/i.test(file.name || "")
      ),
      unconfirmedCartMessage = "We could not confirm that your cart received the engraving proof and original artwork. Please inspect your cart before trying again. This page will not submit again; no cart items were removed.",
      artworkMessage = () => uploadError || (uploadBusy
        ? isPdfFile(upload.files[0])
          ? "Rendering your one-page PDF artwork preview…"
          : "Preparing your artwork preview…"
        : ""),
      resetUploadPreview = () => {
        uploadToken += 1;
        if (uploadedPreview) URL.revokeObjectURL(uploadedPreview);
        uploadedPreview = null;
        previewFile = null;
        uploadBusy = !1;
        uploadReady = !1;
        uploadError = "";
      },
      withDeadline = (promise, message) => {
        let timer;
        return Promise.race([
          promise,
          new Promise((_, reject) => { timer = setTimeout(() => reject(new Error(message)), 20000); }),
        ]).finally(() => clearTimeout(timer));
      },
      assertVisibleImage = image => {
        const rect = image.getBoundingClientRect(),
          stageRect = stage.getBoundingClientRect(),
          styles = getComputedStyle(image);
        if (image.hidden || !image.complete || !image.naturalWidth || !image.naturalHeight ||
            !rect.width || !rect.height || !stageRect.width || !stageRect.height ||
            styles.display === "none" || styles.visibility === "hidden" ||
            Number(styles.opacity) === 0 ||
            rect.right <= stageRect.left || rect.left >= stageRect.right ||
            rect.bottom <= stageRect.top || rect.top >= stageRect.bottom)
          throw new Error("Your artwork preview is not visible. Please choose a readable image or one-page PDF and wait for its preview.");
      },
      assertUploadReady = () => {
        const file = upload.files[0];
        if (!file) {
          if (uploadedPreview || previewFile || uploadBusy)
            throw new Error("Your artwork selection changed. Please select a design, enter text, or upload the artwork again.");
          return;
        }
        if (text.value.trim()) throw new Error("Please choose either uploaded artwork or custom text, not both.");
        if (uploadBusy) throw new Error(artworkMessage());
        if (uploadError) throw new Error(uploadError);
        if (!uploadReady || previewFile !== file || !uploadedPreview || artImg.src !== uploadedPreview)
          throw new Error("Please wait for a successful artwork preview before adding your engraving. Images and one-page PDFs are supported.");
        assertVisibleImage(artImg);
      },
      configurationSnapshot = () => ({
        token: uploadToken,
        uploadedFile: upload.files[0] || null,
        customText: text.value.trim(),
        model: model.value,
        color,
        design,
        scale: scale.value,
        x: point.x,
        y: point.y,
        artworkSource: artImg.src,
        lidSource: lid.src,
        rush: form.querySelector("[data-pc-rush]").checked,
      }),
      assertConfiguration = expected => {
        const actual = configurationSnapshot();
        if (Object.keys(expected).some(key => expected[key] !== actual[key]))
          throw new Error("Your engraving changed while its proof was being created. Please check the preview and add it again.");
        assertUploadReady();
      },
      resolveSelectedVariant = () => {
        const product = window.pcEngravingProducts && window.pcEngravingProducts[model.value],
          names = finishVariantNames[color];
        if (!product || !product.variants || !product.availability || !Array.isArray(names))
          return {
            available: !1,
            message: "This finish is unavailable. Please choose another finish.",
          };
        const variantId = names.map(name => product.variants[name]).find(id => id !== undefined && id !== null && id !== ""),
          availabilityKey = String(variantId);
        if (variantId === undefined || !Object.prototype.hasOwnProperty.call(product.availability, availabilityKey))
          return {
            available: !1,
            message: "This finish is unavailable. Please choose another finish.",
          };
        return {
          product,
          variantId,
          available: product.availability[availabilityKey] === !0,
          message: "This finish is sold out.",
        };
      },
      syncAvailability = () => {
        const selection = resolveSelectedVariant(),
          file = upload.files[0],
          uploadBlocked = !!file && (uploadBusy || !!uploadError || !uploadReady || previewFile !== file);
        submitButton.disabled = !selection.available || submitting || uploadBlocked || submissionUnconfirmed;
        submitButton.textContent = !selection.available ? "Sold Out"
          : submissionUnconfirmed ? "Check Your Cart"
          : submitting ? "Adding Engraving…"
          : uploadBusy ? "Preparing Artwork…"
          : uploadBlocked ? "Artwork Preview Required"
          : "Add Configured Engraving";
        if (selection.available) {
          if (submissionUnconfirmed) feedback.textContent = unconfirmedCartMessage;
          else if (feedback.dataset.pcStockState === "unavailable") feedback.textContent = artworkMessage();
          feedback.dataset.pcStockState = "available";
        } else {
          feedback.textContent = selection.message;
          feedback.dataset.pcStockState = "unavailable";
        }
        return selection;
      },
      currentGuide = () => guides[model.value] || guides.slim,
      mapRoundPoint = (x, y) => ({
        x: ((x - roundFrame.cropLeft) / roundFrame.visible) * 100,
        y: ((y - roundFrame.cropTop) / roundFrame.visible) * 100,
      }),
      renderGuide = () => {
        const raw = currentGuide(),
          g =
            model.value === "rect"
              ? raw
              : {
                  ...mapRoundPoint(raw.x, raw.y),
                  w: (raw.w / roundFrame.visible) * 100,
                  h: (raw.h / roundFrame.visible) * 100,
                };
        ((stage.dataset.shape = model.value === "rect" ? "rect" : "round"),
          stage.style.setProperty("--pc-guide-x", `${g.x}%`),
          stage.style.setProperty("--pc-guide-y", `${g.y}%`),
          stage.style.setProperty("--pc-guide-w", `${g.w}%`),
          stage.style.setProperty("--pc-guide-h", `${g.h}%`),
          guide.setAttribute(
            "aria-label",
            model.value === "rect"
              ? "Rectangular engraving area"
              : "Round-lid engraving area"
          ));
      },
      renderArt = () => {
        const customText = text.value.trim(),
          uploadedFile = upload.files[0],
          isStock = !uploadedFile && !customText,
          verticalAdjustment = isStock
            ? (stockVerticalAdjustment[design] ??
              stockVerticalAdjustment.default)
            : 0,
          sizeAdjustment = (isStock && stockSizeAdjustment[design]) || 1,
          horizontalShift = model.value === "rect" ? 1 : 0.864,
          rawX = point.x - horizontalShift,
          rawY = point.y + verticalAdjustment,
          framed =
            model.value === "rect"
              ? { x: rawX, y: rawY }
              : mapRoundPoint(rawX, rawY);
        ((artImg.style.transform = `scale(${sizeAdjustment})`),
          (art.style.left = `${framed.x}%`),
          (art.style.top = `${framed.y}%`),
          (art.style.width = `${scale.value}%`),
          customText
            ? ((artImg.hidden = !0),
              (artText.hidden = !1),
              (artText.textContent = customText),
              applyTextScale(customText))
            : uploadedFile && !uploadedPreview
              ? ((artImg.hidden = !0),
                (artText.hidden = !0),
                (artText.textContent = ""),
                applyTextScale(""))
              : ((artImg.hidden = !1),
                (artText.hidden = !0),
                applyTextScale(""),
                artImg.src !== (uploadedPreview || stockArtworkSource) &&
                  (artImg.src = uploadedPreview || stockArtworkSource)));
      },
      describeAxis = (value, center, lowerLabel, upperLabel) => {
        const delta = Math.round(value - center),
          distance = Math.abs(delta);
        if (distance <= 3) return "centered";
        const amount =
          distance <= 10 ? "slightly" : distance <= 22 ? "moderately" : "far";
        return `${amount} ${delta < 0 ? lowerLabel : upperLabel}`;
      },
      describePlacement = () => {
        const center =
            model.value === "rect" ? { x: 50, y: 40 } : { x: 56.8, y: 44.7 },
          horizontal = describeAxis(point.x, center.x, "left", "right"),
          vertical = describeAxis(point.y, center.y, "high", "low");
        if (horizontal === "centered" && vertical === "centered")
          return "Centered";
        if (horizontal === "centered") return `Centered, ${vertical}`;
        if (vertical === "centered")
          return `${horizontal}, vertically centered`;
        return `${horizontal}, ${vertical}`;
      },
      describeSize = () => {
        const value = Number(scale.value),
          label =
            value <= 35
              ? "Small"
              : value <= 55
                ? "Medium"
                : value <= 75
                  ? "Large"
                  : "Extra large";
        return `${label} (${value}% of preview width)`;
      },
      loadCanvasImage = src =>
        withDeadline(new Promise((resolve, reject) => {
          const image = new Image();
          if (!/^(blob:|data:)/i.test(src)) image.crossOrigin = "anonymous";
          image.onload = () => resolve(image);
          image.onerror = () =>
            reject(new Error("Unable to load proof artwork."));
          image.src = src;
        }), "The proof artwork did not finish loading. Please try again."),
      drawContainedImage = (context, image, box, multiplier = 1) => {
        const ratio = Math.min(box.w / image.width, box.h / image.height),
          width = image.width * ratio * multiplier,
          height = image.height * ratio * multiplier;
        context.drawImage(
          image,
          box.x + (box.w - width) / 2,
          box.y + (box.h - height) / 2,
          width,
          height
        );
      },
      applyTextScale = customText => {
        if (!customText) {
          artText.style.removeProperty("font-size");
          return;
        }
        // Text-only range is three times the previous text size at every slider
        // position. Image artwork width and stock transforms stay unchanged.
        artText.style.removeProperty("font-size");
        const cssFontSize = parseFloat(getComputedStyle(artText).fontSize),
          scaledFontSize = cssFontSize * 3 * (Number(scale.value) / 55);
        Number.isFinite(scaledFontSize) &&
          artText.style.setProperty("font-size", `${scaledFontSize}px`);
      },
      customTextProofLayout = (stageRect, outputSize) => {
        const textNode = artText.firstChild,
          styles = getComputedStyle(artText),
          value = artText.textContent || "";
        if (!textNode || !value) return null;

        // Range rectangles are the browser's actual wrapped line fragments.
        // This avoids independently guessing font metrics, word breaks, or a
        // maximum line count for the proof image.
        const lines = [];
        for (let index = 0; index < value.length; index += 1) {
          const range = document.createRange();
          range.setStart(textNode, index);
          range.setEnd(textNode, index + 1);
          const rect = range.getBoundingClientRect();
          if (!rect.width && !rect.height) continue;
          let line = lines.find(item => Math.abs(item.top - rect.top) < 0.5);
          if (!line) {
            line = {
              start: index,
              end: index + 1,
              left: rect.left,
              right: rect.right,
              top: rect.top,
              bottom: rect.bottom,
            };
            lines.push(line);
          } else {
            line.start = Math.min(line.start, index);
            line.end = Math.max(line.end, index + 1);
            line.left = Math.min(line.left, rect.left);
            line.right = Math.max(line.right, rect.right);
            line.top = Math.min(line.top, rect.top);
            line.bottom = Math.max(line.bottom, rect.bottom);
          }
        }
        const transformText =
          styles.textTransform === "uppercase"
            ? value => value.toLocaleUpperCase()
            : styles.textTransform === "lowercase"
              ? value => value.toLocaleLowerCase()
              : value => value;
        return {
          color: styles.color,
          opacity: Number(styles.opacity),
          font: `${styles.fontStyle} ${styles.fontWeight} ${styles.fontSize} ${styles.fontFamily}`,
          letterSpacing:
            styles.letterSpacing === "normal" ? "0px" : styles.letterSpacing,
          wordSpacing: styles.wordSpacing === "normal" ? "0px" : styles.wordSpacing,
          textShadow: styles.textShadow,
          lines: lines
            .sort((a, b) => a.top - b.top || a.left - b.left)
            .map(line => ({
              text: transformText(
                value.slice(line.start, line.end).replace(/\s+/g, " ").trim()
              ),
              x: line.left - stageRect.left,
              y: (line.top + line.bottom) / 2 - stageRect.top,
            }))
            .filter(line => line.text),
        };
      },
      drawCustomTextProof = (context, layout, stageRect, outputSize) => {
        if (!layout || !layout.lines.length) return;
        const scaleX = outputSize / stageRect.width,
          scaleY = outputSize / stageRect.height;
        context.save();
        context.scale(scaleX, scaleY);
        context.fillStyle = layout.color;
        context.globalAlpha = Number.isFinite(layout.opacity) ? layout.opacity : 1;
        context.textAlign = "left";
        context.textBaseline = "middle";
        context.font = layout.font;
        context.letterSpacing = layout.letterSpacing;
        context.wordSpacing = layout.wordSpacing;
        const shadow = layout.textShadow.match(
          /(rgba?\([^)]*\)|#[\da-f]+)\s+(-?[\d.]+)px\s+(-?[\d.]+)px\s+([\d.]+)px/i
        );
        if (shadow) {
          context.shadowColor = shadow[1];
          context.shadowOffsetX = Number(shadow[2]);
          context.shadowOffsetY = Number(shadow[3]);
          context.shadowBlur = Number(shadow[4]);
        }
        layout.lines.forEach(line => context.fillText(line.text, line.x, line.y));
        context.restore();
      },
      createProofFile = async expected => {
        assertConfiguration(expected);
        const proof = document.createElement("canvas"),
          size = 900,
          detailsHeight = 265;
        proof.width = size;
        proof.height = size + detailsHeight;
        const context = proof.getContext("2d");
        if (!context) throw new Error("Unable to create engraving proof.");

        // Grid intrinsic sizing can make the visible image taller than its box.
        // Use rendered bounds, including stock transforms, instead of guessing.
        const uploadedFile = upload.files[0],
          customText = text.value.trim(),
          isStock = !uploadedFile && !customText,
          hasImageArtwork = !customText && (isStock || (uploadReady && previewFile === uploadedFile && !!uploadedPreview));
        if (uploadedFile && !hasImageArtwork)
          throw new Error("A visible artwork preview is required before creating your engraving proof.");
        await withDeadline(Promise.all([
          lid.decode(),
          ...(hasImageArtwork ? [artImg.decode()] : []),
          ...(customText && document.fonts ? [document.fonts.ready] : []),
        ]), "The engraving preview did not finish loading. Please wait for a visible preview and try again.");
        assertConfiguration(expected);
        if (hasImageArtwork) assertVisibleImage(artImg);
        const stageRect = stage.getBoundingClientRect();
        if (!stageRect.width || !stageRect.height)
          throw new Error("Unable to measure the engraving preview.");
        const previewBox = element => {
          const rect = element.getBoundingClientRect();
          return {
            x: ((rect.left - stageRect.left) / stageRect.width) * size,
            y: ((rect.top - stageRect.top) / stageRect.height) * size,
            w: (rect.width / stageRect.width) * size,
            h: (rect.height / stageRect.height) * size,
          };
        };
        const lidBox = previewBox(lid),
          imageBox = hasImageArtwork ? previewBox(artImg) : null,
          textBox = customText ? previewBox(artText) : null,
          textLayout = customText
            ? customTextProofLayout(stageRect, size)
            : null,
          artworkOpacity = hasImageArtwork
            ? Number(getComputedStyle(artImg).opacity)
            : 1,
          lidSource = lid.currentSrc || lid.src,
          artworkSource = hasImageArtwork ? artImg.currentSrc || artImg.src : null;

        if (customText && (!textLayout || !textLayout.lines.length || artText.hidden || !textBox.w || !textBox.h))
          throw new Error("Your custom text is not visible in the preview. Please check the text and placement before adding it.");
        context.fillStyle = "#07111c";
        context.fillRect(0, 0, proof.width, proof.height);

        const lidImage = await loadCanvasImage(lidSource);
        assertConfiguration(expected);
        if (model.value === "rect") {
          drawContainedImage(context, lidImage, lidBox);
        } else {
          context.drawImage(
            lidImage,
            lidBox.x,
            lidBox.y,
            lidBox.w,
            lidBox.h
          );
        }

        const verticalAdjustment = isStock
            ? (stockVerticalAdjustment[design] ??
              stockVerticalAdjustment.default)
            : 0,
          horizontalShift = model.value === "rect" ? 1 : 0.864,
          rawX = point.x - horizontalShift,
          rawY = point.y + verticalAdjustment,
          framed =
            model.value === "rect"
              ? { x: rawX, y: rawY }
              : mapRoundPoint(rawX, rawY),
          box = {
            w: (Number(scale.value) / 100) * size,
            h: (model.value === "rect" ? 0.42 : 0.38) * size,
          };
        box.x = (framed.x / 100) * size - box.w / 2;
        box.y = (framed.y / 100) * size - box.h / 2;
        customText && Object.assign(box, textBox);

        context.save();
        context.beginPath();
        context.rect(0, 0, size, size);
        context.clip();

        if (customText) {
          drawCustomTextProof(context, textLayout, stageRect, size);
        } else if (hasImageArtwork) {
          const artworkImage = await loadCanvasImage(artworkSource);
          assertConfiguration(expected);
          Object.assign(box, imageBox);
          context.globalAlpha = artworkOpacity;
          drawContainedImage(context, artworkImage, box);
          context.globalAlpha = 1;
        } else {
          throw new Error("A visible artwork preview is required before creating your engraving proof.");
        }

        context.strokeStyle = "#35baf2";
        context.lineWidth = 5;
        context.setLineDash([16, 12]);
        context.strokeRect(box.x, box.y, box.w, box.h);
        context.restore();

        const product = window.pcEngravingProducts[model.value],
          designLabel = customText
            ? `Custom text: ${customText}`
            : uploadedFile
              ? `Customer upload: ${uploadedFile.name}`
              : design;
        context.fillStyle = "#07111c";
        context.fillRect(0, size, size, detailsHeight);
        context.fillStyle = "#ffffff";
        context.textAlign = "left";
        context.textBaseline = "alphabetic";
        context.font = "700 34px Arial, sans-serif";
        context.fillText("ENGRAVING PLACEMENT PROOF", 44, size + 52);
        context.fillStyle = "#b8c8d2";
        context.font = "600 24px Arial, sans-serif";
        context.fillText(
          `${product.title} · ${finishNames[color]}`,
          44,
          size + 94
        );
        context.font = "600 22px Arial, sans-serif";
        context.fillText(
          `Artwork: ${designLabel.slice(0, 65)}`,
          44,
          size + 130
        );
        context.fillText(`Placement: ${describePlacement()}`, 44, size + 166);
        context.fillText(
          `Coordinates: X ${Math.round(point.x)}%, Y ${Math.round(point.y)}% · Size: ${describeSize()}`,
          44,
          size + 202
        );
        context.fillStyle = "#7e96a4";
        context.font = "500 20px Arial, sans-serif";
        context.fillText(
          "Blue dashed box = selected artwork bounds",
          44,
          size + 238
        );

        const blob = await new Promise((resolve, reject) =>
          proof.toBlob(
            value =>
              value && value.size
                ? resolve(value)
                : reject(new Error("Unable to export proof image.")),
            "image/png",
            0.94
          )
        );
        assertConfiguration(expected);
        return new File([blob], "precision-carry-engraving-proof.png", {
          type: "image/png",
        });
      },
      setLid = (reset = !1) => {
        const filename = lids[model.value][color],
          base = lid.src.slice(0, lid.src.lastIndexOf("/") + 1);
        if (((lid.src = base + filename), renderGuide(), reset)) {
          const g = currentGuide();
          point =
            model.value === "rect"
              ? { x: g.x, y: g.y - 10 }
              : { x: 56.8, y: 44.7 };
        }
        renderArt();
      },
      prepareUpload = async () => {
        resetUploadPreview();
        const file = upload.files[0],
          token = uploadToken;
        if (!file) {
          feedback.textContent = "";
          renderArt();
          syncAvailability();
          return;
        }
        let previewUrl = null;
        const current = () => token === uploadToken && upload.files[0] === file && !text.value.trim();
        uploadBusy = !0;
        text.value = "";
        form.querySelectorAll("[data-pc-design]")
          .forEach(item => item.setAttribute("aria-pressed", "false"));
        renderArt();
        feedback.textContent = artworkMessage();
        syncAvailability();
        try {
          if (!file.size) throw new Error("Please upload a nonempty image or one-page PDF.");
          let previewBlob = file;
          if (isPdfFile(file)) {
            if (!window.pcPdfArtwork || typeof window.pcPdfArtwork.render !== "function")
              throw new Error("The PDF preview reader is unavailable. Please reload this page or upload a PNG, JPG or SVG. One-page PDFs are supported.");
            const result = await window.pcPdfArtwork.render(file);
            if (!current()) return;
            if (!result || !(result.blob instanceof Blob) || !result.blob.size ||
                String(result.blob.type).toLowerCase() !== "image/png" ||
                !(result.width > 0 && result.height > 0) || !Number.isFinite(result.width + result.height) ||
                result.pageNumber !== 1 || result.pageCount !== 1)
              throw new Error("The PDF did not produce a usable one-page artwork preview. Please export it again or upload a PNG, JPG or SVG.");
            previewBlob = result.blob;
          }
          if (!current()) return;
          previewUrl = URL.createObjectURL(previewBlob);
          uploadedPreview = previewUrl;
          previewFile = file;
          artImg.alt = isPdfFile(file) ? "Rendered one-page PDF artwork preview" : "Uploaded artwork preview";
          renderArt();
          await withDeadline(artImg.decode(), "The artwork preview did not finish loading. Please choose a readable image or one-page PDF and try again.");
          if (!current()) return;
          assertVisibleImage(artImg);
          // Detect fully transparent uploads without changing their preview or proof pixels.
          const check = document.createElement("canvas"),
            ratio = Math.min(1, 1800 / Math.max(artImg.naturalWidth, artImg.naturalHeight));
          check.width = Math.max(1, Math.round(artImg.naturalWidth * ratio));
          check.height = Math.max(1, Math.round(artImg.naturalHeight * ratio));
          const context = check.getContext("2d", { willReadFrequently: true });
          if (!context) throw new Error("Unable to check your artwork preview. Please try a current browser.");
          context.drawImage(artImg, 0, 0, check.width, check.height);
          const pixels = context.getImageData(0, 0, check.width, check.height).data;
          let visible = false;
          for (let index = 3; index < pixels.length; index += 4) {
            if (pixels[index] > 16) { visible = true; break; }
          }
          if (!visible) throw new Error("Your upload has no visible artwork. Please choose an image or one-page PDF containing a visible design.");
          uploadReady = !0;
          feedback.textContent = isPdfFile(file)
            ? "Your one-page PDF artwork is rendered in the preview. The original PDF and placement proof will be attached to your order."
            : "Your artwork preview is ready. The original file and placement proof will be attached to your order.";
        } catch (error) {
          if (!current()) return;
          if (uploadedPreview) URL.revokeObjectURL(uploadedPreview);
          uploadedPreview = null;
          previewFile = null;
          uploadReady = !1;
          uploadError = isPdfFile(file) && error instanceof Error ? error.message
            : "Unable to preview this artwork. Please choose a readable, nonempty PNG, JPG, SVG or one-page PDF.";
          feedback.textContent = uploadError;
          renderArt();
        } finally {
          if (previewUrl && previewUrl !== uploadedPreview) URL.revokeObjectURL(previewUrl);
          if (current()) {
            uploadBusy = !1;
            syncAvailability();
          }
        }
      },
      selectDesign = button => {
        if (submitting || button.disabled) return;
        resetUploadPreview();
        ((design = button.dataset.pcDesignName),
          (upload.value = ""),
          (text.value = ""),
          (artImg.hidden = !1),
          (artText.hidden = !0),
          (artImg.src = button.dataset.pcDesignUrl),
          (stockArtworkSource = artImg.src),
          (artImg.alt = `${design} engraving preview`),
          form
            .querySelectorAll("[data-pc-design]")
            .forEach(item =>
              item.setAttribute(
                "aria-pressed",
                item === button ? "true" : "false"
              )
            ),
          (feedback.textContent = ""),
          renderArt(),
          syncAvailability());
      };
    (document.addEventListener(
      "click",
      event => {
        const tile =
          event.target.closest && event.target.closest("[data-pc-design]");
        tile && form.contains(tile) && selectDesign(tile);
      },
      !0
    ),
      form.querySelectorAll("[data-pc-color]").forEach(button =>
        button.addEventListener("click", () => {
          if (submitting || button.disabled) return;
          ((color = button.dataset.pcColor),
            form
              .querySelectorAll("[data-pc-color]")
              .forEach(item =>
                item.setAttribute(
                  "aria-pressed",
                  item === button ? "true" : "false"
                )
              ),
            setLid(!1),
            syncAvailability());
        })
      ),
      model.addEventListener("change", () => {
        if (submitting) return;
        setLid(!0);
        syncAvailability();
      }),
      form
        .querySelectorAll("[data-pc-design]")
        .forEach(button =>
          button.addEventListener("click", () => selectDesign(button))
        ),
      upload.addEventListener("change", () => {
        if (submitting) return;
        void prepareUpload();
      }),
      text.addEventListener("input", () => {
        if (submitting) return;
        resetUploadPreview();
        ((upload.value = ""),
          form
            .querySelectorAll("[data-pc-design]")
            .forEach(item => item.setAttribute("aria-pressed", "false")),
          (feedback.textContent = ""),
          renderArt(),
          syncAvailability());
      }),
      scale.addEventListener("input", () => { if (!submitting) renderArt(); }),
      art.addEventListener("pointerdown", event => {
        if (submitting) return;
        ((drag = {
          x: event.clientX,
          y: event.clientY,
          px: point.x,
          py: point.y,
        }),
          art.setPointerCapture(event.pointerId));
      }),
      art.addEventListener("pointermove", event => {
        if (!drag || submitting) return;
        const rect = stage.getBoundingClientRect();
        ((point.x = Math.max(
          8,
          Math.min(92, drag.px + ((event.clientX - drag.x) / rect.width) * 100)
        )),
          (point.y = Math.max(
            8,
            Math.min(
              92,
              drag.py + ((event.clientY - drag.y) / rect.height) * 100
            )
          )),
          renderArt());
      }),
      art.addEventListener("pointerup", () => {
        drag = null;
      }),
      form.addEventListener("reset", event => {
        if (submitting) { event.preventDefault(); return; }
        resetUploadPreview();
        setTimeout(() => {
          feedback.textContent = "";
          setLid(!0);
          syncAvailability();
        }, 0);
      }),
      form.addEventListener("submit", async event => {
        event.preventDefault();
        if (submitting) return;
        const selection = syncAvailability();
        if (!selection.available) return;
        if (submissionUnconfirmed) { feedback.textContent = unconfirmedCartMessage; return; }
        try { assertUploadReady(); }
        catch (error) {
          feedback.textContent = error instanceof Error ? error.message : "Please wait for your artwork preview.";
          syncAvailability();
          return;
        }
        const expected = configurationSnapshot();
        submitting = !0;
        syncAvailability();
        const controls = Array.from(form.querySelectorAll("input, select, button"))
          .filter(control => control !== submitButton && !control.disabled);
        controls.forEach(control => { control.disabled = true; });
        const previousPointerEvents = art.style.pointerEvents;
        art.style.pointerEvents = "none";
        drag = null;
        feedback.textContent = "Creating your engraving placement proof…";
        let cartRequestStarted = !1,
          cartRequestRejected = !1,
          cartConfirmed = !1;
        try {
          const { product, variantId } = selection,
            proofFile = await createProofFile(expected),
            data = new FormData(),
            customText = expected.customText,
            uploadedFile = expected.uploadedFile,
            proofStatus = isPdfFile(uploadedFile) ? "Rendered PDF preview attached." : "Rendered placement proof attached.",
            designLabel = customText
              ? `Custom text: ${customText}`
              : uploadedFile
                ? `Customer upload: ${uploadedFile.name}`
                : design,
            items = [
              {
                id: variantId,
                quantity: 1,
                properties: {
                  "Engraving design": designLabel,
                  "Engraving finish": finishNames[color],
                  "Artwork placement": `${describePlacement()} (X ${Math.round(point.x)}%, Y ${Math.round(point.y)}%)`,
                  "Artwork size": describeSize(),
                  "Engraving proof status": proofStatus,
                },
              },
              {
                id: window.pcEngravingAddons.engraving,
                quantity: 1,
                properties: { "For product": product.title },
              },
            ];
          expected.rush &&
            items.push({
              id: window.pcEngravingAddons.rush,
              quantity: 1,
              properties: { "For product": product.title },
            });
          items.forEach((item, index) => {
            (data.append(`items[${index}][id]`, item.id),
              data.append(`items[${index}][quantity]`, item.quantity),
              Object.entries(item.properties).forEach(([key, value]) =>
                data.append(`items[${index}][properties][${key}]`, value)
              ));
          });
          uploadedFile &&
            data.append("items[0][properties][Artwork file]", uploadedFile);
          data.append("items[0][properties][Engraving proof]", proofFile);
          assertConfiguration(expected);
          const latestSelection = resolveSelectedVariant();
          if (!latestSelection.available || String(latestSelection.variantId) !== String(variantId))
            throw new Error(latestSelection.message || "This finish is unavailable. Please choose another finish.");
          feedback.textContent = "Uploading your engraving proof…";
          cartRequestStarted = !0;
          const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            body: data,
          });
          if (!response.ok) {
            // Explicit 4xx rejection is retryable. Network/5xx/success without
            // attachments is indeterminate; never silently send another add.
            cartRequestRejected = response.status >= 400 && response.status < 500;
            throw new Error("Unable to add this configuration.");
          }
          const result = await response.json(),
            returnedItems = result && Array.isArray(result.items) ? result.items : [result],
            isAttachment = value => typeof value === "string" && /^(https?:\/\/|\/)/i.test(value.trim()),
            configuredItem = returnedItems.find(item => {
              if (!item || String(item.variant_id || item.id) !== String(variantId)) return false;
              const properties = item.properties;
              return properties && isAttachment(properties["Engraving proof"]) &&
                (!uploadedFile || isAttachment(properties["Artwork file"])) &&
                Object.entries(items[0].properties).every(([key, value]) => properties[key] === value);
            });
          if (!configuredItem) throw new Error(unconfirmedCartMessage);
          cartConfirmed = !0;
          feedback.textContent = "Your engraving proof is attached. Opening your cart…";
          window.location.assign(window.Shopify.routes.root + "cart");
        } catch (error) {
          if (cartRequestStarted && !cartRequestRejected && !cartConfirmed) submissionUnconfirmed = !0;
          feedback.textContent = submissionUnconfirmed ? unconfirmedCartMessage : cartConfirmed
            ? "Your engraving and proof were added. Please open your cart to continue; do not submit again."
            : error instanceof Error
              ? error.message
              : "Unable to create the engraving proof. Please try again.";
        } finally {
          controls.forEach(control => { control.disabled = false; });
          art.style.pointerEvents = previousPointerEvents;
          submitting = cartConfirmed;
          syncAvailability();
        }
      }),
      setLid(!0),
      syncAvailability());
  };
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot, { once: !0 })
    : boot();
})();
